import React from "react";
import { BsStarFill } from "react-icons/bs";



export default function Productlist({articles}) {
console.log(articles);
  return (
    <div className="product-inner">
      <div className="product-image text-center">
        <img className="img-fluid" src={articles.image} alt="" />
      </div>
      <div className="product-description">
      <h4 className="product-title">{articles.title}</h4>
        <ul className="rating-products">
          <li>
            <BsStarFill />
          </li>        

          <li>Rating {articles.rating.rate}</li>
        </ul>
        <b className="text-grey">Category : {articles.category}</b>
        <p className="price">
          <span className="">Price : {articles.price}</span> &nbsp; 
        </p>
        <button className="btn addtocart">Add to cart</button>
      </div>
    </div>
  );
}


Productlist.defaultProps  = {
 

}


// api ki value yha pass hogi in 3 me dara fetch kaunga
